import tableNew from '@disy/cadenza-icons/table.svg';

import { VIEW } from 'cadenza/map-dashboard/event-types';
import { LayerProperty } from 'cadenza/map/layer-property';
import { hasAttributeTable } from 'cadenza/map/layer-utils';
import { icon } from 'cadenza/utils/icon/icon';
import i18n from 'cadenza/map/layer-actions/layer-actions.properties';

import { LayerAction } from './layer-action';

export class ShowAttributeTable extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, Object.assign({
      label: i18n('showTable'),
      icon: icon(tableNew)
    }, options));
    this.#map = options.map;
  }

  executeSync () {
    const mapView = document.querySelector('d-map-view');
    const layerAttributes = this.layer.get(LayerProperty.ATTRIBUTES);
    mapView.dispatchEvent(new CustomEvent(VIEW.TOGGLE_TABLE_VISIBILITY, {
      bubbles: true,
      detail: {
        'isVisible': true,
        'tableUrl': layerAttributes.url,
        'geometryAttribute': layerAttributes.geometryAttribute,
        'geometrySrs': layerAttributes.projection.code,
        'viewId': this.layer.get(LayerProperty.ID)
      }
    }));
  }

  isSupportedSync ({ isEditingLayer }) {
    return !isEditingLayer && hasAttributeTable(this.layer);
  }

}
